import { FormattedMessage, useIntl } from 'react-intl';
import { Stack, Typography, useTheme } from '@mui/material';

import { FC } from 'react';
import ImageBoxFuture from '@/components/shared/image-box-future';

interface WalletSidMenuAuthHintProps {
  message: string;
  img: File | string;
  textColor?: string;
}

export const WalletSidMenuAuthHint: FC<WalletSidMenuAuthHintProps> = ({
  message,
  img,
  textColor,
}) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
      }}
    >
      <ImageBoxFuture
        img={img}
        title={intl.formatMessage({
          id: 'alt.my_wallet',
        })}
        objectFit='contain'
        sx={{
          minWidth: '31px',
          minHeight: '35px',
        }}
      />
      <Typography
        component='span'
        sx={{
          fontSize: '16px',
          color: textColor || theme.palette.grey[60],
          marginX: '7px',
        }}
      >
        <FormattedMessage id={message} />
      </Typography>
    </Stack>
  );
};
